// extracted by mini-css-extract-plugin
module.exports = {"input":"QuestionsForm_input__x2kOV","label":"QuestionsForm_label__Khfm1","checkbox":"QuestionsForm_checkbox__3mXA7"};